import { ApiError } from '@talon/web/lib/api';
import posthog from 'posthog-js';

/**
 * Sends an error to PostHog error tracking, tagged with the API request ID when it came from an
 * API call. Returns a short reference for server errors (the first 8 characters of the request
 * ID) that can be shown to the user and matched against the API's logs, or undefined otherwise.
 */
export const reportError = (error: unknown): string | undefined => {
  const apiError = error instanceof ApiError ? error : undefined;
  const requestId: string | undefined = apiError?.body?.requestId;

  try {
    posthog.captureException(error, {
      requestId,
      status: apiError?.status,
      method: apiError?.request.method,
      url: apiError?.url,
    });
  } catch {
    // Never let error reporting turn into a second failure
  }

  return apiError && apiError.status >= 500 && requestId ? requestId.slice(0, 8) : undefined;
};
